// extracted by mini-css-extract-plugin
export default {"base":"ExpirationBar_base__L8-ap","is-expiring":"ExpirationBar_is-expiring__NjX-z","base--variant-chip":"ExpirationBar_base--variant-chip__2bz+U"};